module.exports = __webpack_public_path__ + "static/card-children-3c2261b0c409794c9373bda56b6ec0e4.jpg";